Dygraph = require('dygraph')
moment = require('moment')
_ = require('lodash')

module.exports = (
  $scope,
  $rootScope,
  $stateParams,
  $q,
  $timeout,
  $location,
  $uibModal,
  $state,
  $document,
  $filter,
  Api,
  arachnysDateFilter,
  iteration,
  search,
  settings,
  workers,
  manualSources,
  starredDocs,
  SearchWorkers,
  SubdivisionAggregator,
  User,
  adverseTermsLists
  ) ->
  {projectId, workflowId, stepId, iterationId} = $stateParams

  # =========================
  # -------- Actions --------
  # =========================

  $scope.deleteResult = (result, reason) ->
    result.deleted = true
    result.delete_reason = reason
    result.$update()

  $scope.toggleSortOrder = () ->
    $scope.sortOrderDesc = !$scope.sortOrderDesc
    $scope.sortOrder = 'Asc'
    if $scope.sortOrderDesc
      $scope.sortOrder = 'Desc'
    $scope.refineSearch()

  $scope.sortBy = (type) ->
    $scope.refine_query.sortBy = type
    $scope.refineSearch()

  $scope.setStepComplete = () ->
    if not $scope.step.complete
      $scope.toggleStepComplete(true)

  $scope.requestSupportIfNoRequests = () ->
    if not $scope.researchRequests.length
      $scope.showDataConciergeOrderModal()

  $scope.goToUnsearchSourcesIfTheyAreIncomplete = () ->
    if not $scope.checkUnsearchedSourcesComplete()
      $state.go('project.workflow.step.iteration.facets.manualchecks')

  $scope.showKrakenSnapshot = (worker) ->
    krakenModal = $uibModal.open
      template: require("./KrakenSnapshot/kraken-snapshot-modal.html")
      controller: "KrakenModalController"
      size: "lg"
      resolve:
        image: () ->
          return worker.kraken_snapshot

  $scope.uploadDoc = (source) ->
    requestModal = $uibModal.open
      template: require('../../../StarredDocumentUpload/starred-doc-upload-modal.html')
      controller: 'StarredDocumentUploadController'
      size: 'lg'
      resolve:
        workflowStep: () ->
          return $scope.step
        manualSource: () ->
          return source.id
    requestModal.result.then (starredDocument) ->

  $scope.toggleDeletedResultsVisibility = () ->
    $scope.deletedResultsVisible = !$scope.deletedResultsVisible

  $scope.toggleDuplicatedResultsVisibility = () ->
    $scope.duplicatedResultsVisible = !$scope.duplicatedResultsVisible

  $scope.toggleNonAdverseResultsVisibility = () ->
    $scope.nonAdverseResultsVisible = !$scope.nonAdverseResultsVisible

  $scope.getNumberDeletedResults = (results) ->
    (result for result in results or [] when result.deleted).length

  $scope.getNumberDuplicatedResults = (results) ->
    (result for result in results or [] when result.duplicated).length

  $scope.getNumberOfNonAdverseResults = (results) ->
    (result for result in results or [] when result.auto_disposition_is_adverse == false).length

  #returns excluded filters, reset it if user exclude all available
  $scope.getExcludedAdditionalFilters = (additionalFiltersFacet, excludeAdditionalFilters) ->

    if additionalFiltersFacet? and additionalFiltersFacet.length and
       excludeAdditionalFilters? and Object.keys(excludeAdditionalFilters).length

      results = {}
      additionalFiltersFacet.forEach (facet) ->
        if facet.id of excludeAdditionalFilters
          if facet.values.length > excludeAdditionalFilters[facet.id].length
            results[facet.id] = excludeAdditionalFilters[facet.id]
          else
            results[facet.id] = []

      return results

  # =========================
  # ------ Data Load --------
  # =========================

  $scope.subdivisionsFacet = []
  $scope.includeSubdivisions = []
  $scope.excludeSubdivisions = []

  @onWorkersPolled = ( workers ) ->
    $scope.filterWorkers()
    $scope.updateOverviews()
    $scope.updateFacets()
    $scope.setLoaded(true)

    Api.ManualWorkflowStepIteration.query({
      iteration: iteration.id
    }).$promise.then ( manualChecks ) ->
      $scope.setManualChecks( manualChecks )

  $scope.pollWorkers = () =>

    if $scope.workers.hasRunning() and search.id
      $scope.workers.startPolling( {search: search.id}, @onWorkersPolled )

      $scope.$on '$destroy', () ->
        $scope.workers.stopPolling()

  $scope.updateFacets = () ->
    $scope.subdivisionsFacet = SubdivisionAggregator.aggregate($scope.workers)

  $scope.filterWorkers = () ->
    workers = SubdivisionAggregator.filterWorkers(
      $scope.workers,
      $scope.includeSubdivisions,
      $scope.excludeSubdivisions)
    $scope.filteredWorkers.set(workers)

  $scope.updateOverviews = ->
    # If we have any worker, load up the top results for the sources.
    # @Roey: This used to check for > 1, but due to a bug is now set to zero.
    if $scope.workers.getCount() > 0
      for worker in $scope.workers.getWithResults() when not (worker.id of $scope.overviews)
        $scope.overviews[ worker.id ] = worker.queryResults( $scope.overview_results_limit, 0, prefetch_next_page = "false" )

  $scope.setDateRange = (min, max) ->
    $scope.timelineMinDate = min
    $scope.timelineMaxDate = max

  $scope.setDateRefinementMade = (dateRefinementMade) ->
    $scope.dateRefinementMade = dateRefinementMade

  $scope.setRefinementMade = (refinementMade) ->
    $scope.refinementMade = refinementMade

  redirectToIteration = (projectId, workflowId, stepId, iterationId) ->
    $scope.refreshStepIterations()
    params =
      projectId: projectId
      workflowId: workflowId
      workflowStepId: stepId
      iterationId: iterationId
    options =
      reload: true
    stateName = 'project.workflow.step.iteration'
    $state.go(stateName, params, options)

  $scope.runIterationOrRefineSearch = () ->
    iterationShouldRun = $scope.iteration.job_status == "not_yet_started" and not $scope.refinementMade

    if iterationShouldRun
      run_iteration = new Api.RunIteration({id: $scope.iteration.id})
      run_iteration.$save().then(() ->
        redirectToIteration(
          $scope.project.id,
          $scope.workflow.id,
          $scope.step.id,
          $scope.iteration.id)
      )
    else
      $scope.refineSearch()

  _refineCountry = (country) ->
    if not country
      return $scope.iteration.base_countries
    base_countries = [country.id]
    # Make sure we also send 201 (International sources) if that was selected previously
    if 201 in $scope.iteration.base_countries
      base_countries.push(201)
    return base_countries

  $scope.refineSearch = () ->
    if $scope.step.completion_required && $scope.step.complete
      $scope.toggleStepComplete(false)
    base_countries = _refineCountry($scope.iteration.refineCountry)

    if $scope.isDeltaSearch
      # A Time Delta search is meant to show everything that was published after the
      # previous search, so we should leave the `to_date` blank.
      # (We could possibly use `today()`, but leaving it blank means that if the user
      # clicks "Go" afterwards, the new one will also include any new results, so
      # leaving it blank seems better. Also it is the historic behaviour. In any case,
      # we should NOT just keep the previous `to_date`.)
      to_date = null

      # If the previous search did NOT have a `to_date`, then it would have included all
      # results until the date when it was made, and therefore we should use the
      # `created_date` of the previous search as `from_date` for the delta search.
      # This assumes that the underlying source treats `from_date` inclusively
      # (ie: results published exactly on that date will be shown), to guarantee that
      # any results published between the time when the user performed the previous
      # search and the end of that day are also included. This may duplicate any results
      # published on that date but before the user did the previous search, but that is
      # better than risking losing any results.
      previous_search_creation_date = $scope.iteration.created_date
      from_date = moment(previous_search_creation_date).format('YYYY-MM-DD')

      # If the previous search had a `to_date`, then it is a bit trickier to ensure
      # that we catch all new results that were not included in the previous search:
      #
      #     - if, when creating the previous search, the user had set the `to_date` in
      #       the past, we need to use it as `from_date` to make sure that we catch all
      #       the results published between the `to_date` and when the new search was
      #       made
      #     - if the user had used a `to_date` in the future, then we should show all
      #       results published since the search creation date.
      # Note that all this also assumes that from_date works inclusively
      previous_search_end_date = null

      # some SearchWorkers use `to_date` and others `factiva_end_date`
      if $scope.worker?.to_date
        previous_search_end_date = moment($scope.worker.to_date)
      else if $scope.worker?.factiva_end_date
        previous_search_end_date = moment($scope.worker.factiva_end_date)

      if previous_search_end_date && previous_search_end_date.isBefore(previous_search_creation_date)
        from_date = previous_search_end_date.format('YYYY-MM-DD')
    else
      # For regular searches (non time delta), if the user touched one of the UI
      # controls for `from_date` or `to_date` we just take that value. Otherwise we
      # make them default to whatever was used in the previous iteration.
      from_date = null
      to_date = null

      # the user has changed the date range
      if $scope.dateRefinementMade
        if $scope.timelineMinDate
          from_date = moment($scope.timelineMinDate).format('YYYY-MM-DD')
        if $scope.timelineMaxDate
          to_date = moment($scope.timelineMaxDate).format('YYYY-MM-DD')
      else
        # the user didn't change the date range
        # we should use the date range used in the previous iteration if it exists
        if $scope.worker?.from_date
          from_date = moment($scope.worker.from_date).format('YYYY-MM-DD')
        else if $scope.worker?.factiva_start_date
          from_date = moment($scope.worker.factiva_start_date).format('YYYY-MM-DD')

        if $scope.worker?.to_date
          to_date = moment($scope.worker.to_date).format('YYYY-MM-DD')
        else if $scope.worker?.factiva_end_date
          to_date = moment($scope.worker.factiva_end_date).format('YYYY-MM-DD')

    $scope.setLoaded(false)

    if Array.isArray($scope.iteration.subdivisions)
      subdivisions = $scope.iteration.subdivisions
    else
      subdivisions =  if $scope.iteration.subdivisions then [$scope.iteration.subdivisions] else undefined

    includeAdditionalFilters =  $scope.setAdditionalSearchTerms($scope, $scope.includeAdditionalFilters)
    excludeAdditionalFilters = $scope.getExcludedAdditionalFilters($scope.additionalFiltersFacet, $scope.excludeAdditionalFilters)
    iteration = new Api.WorkflowStepIteration({
      query: if $scope.refine_query.query then $scope.refine_query.query else $scope.iteration.query,
      additional_filter_terms: $scope.iteration.additional_filter_terms,
      translated_query : if $scope.iteration.translated_query then $scope.refine_query.query,
      country: $scope.iteration.country,
      translated_to_language: $scope.iteration.translated_to_language,
      translated_from_language: $scope.iteration.translated_from_language,
      workflow_step: $scope.iteration.workflow_step,
      category: $scope.iteration.category,
      categories: $scope.iteration.categories,
      collection: $scope.iteration.collection,
      from_date: from_date,
      to_date: to_date,
      adverse_terms: $scope.adverseTerms,
      adverse_terms_list: $scope.adverseTermsList?.id,
      base_countries: base_countries,
      countries: $scope.includeCountries,
      subdivisions: subdivisions,
      exclude_countries: $scope.excludeCountries,
      include_sources: $scope.includeSources,
      exclude_sources: $scope.excludeSources,
      sort_by: $scope.refine_query.sortBy,
      sort_order_desc: $scope.sortOrderDesc,
      dirty_words_connector: $scope.dirty_words_connector || $scope.iteration.dirty_words_connector,
      parent: $scope.iteration.id,
      merged_name_variations: $scope.nameVariations || undefined,
      min_score: $scope.minScore,
      include_additional_filters: includeAdditionalFilters,
      exclude_additional_filters: excludeAdditionalFilters,
      search_term_type: $scope.iteration.search_term_type,
      is_delta_search: $scope.isDeltaSearch,
    })
    iteration.$save().then (iteration) ->
      $scope.iteration = iteration
      $scope.initSubdivisionsSelect()
      redirectToIteration(
        $scope.project.id,
        $scope.workflow.id,
        $scope.step.id,
        iteration.id)

  $scope.runTimeDelta = () ->
    $scope.isDeltaSearch = true
    $scope.setDateRefinementMade(true)
    $scope.refineSearch()

  $scope.editAdverseTerms = (iteration) ->
    modalInstance = $uibModal.open(
      template: require('./adverse-terms.html'),
      controller: 'AdverseTermsPopupController',
      resolve:
        iteration: () ->
          iteration or $scope.iteration
        projectPermissions: () ->
          $scope.projectPermissions
        proximity: ->
          search.dirty_words_connector
        adverseTermsLists: ->
          $scope.adverseTermsLists
    )

    modalInstance.result.then (terms) ->
      $scope.adverseTerms = terms.adverseTerms
      $scope.adverseTermsList = terms.adverseTermsList
      if iteration
        iteration.adverse_terms = terms.adverseTerms
        iteration.adverse_terms_list = terms.adverseTermsList.id
      $scope.dirty_words_connector = terms.proximity
      $scope.refineSearch()

  $scope.turnOffAdverseTerms = () ->
    $scope.iteration.adverse_terms = ''
    $scope.iteration.adverse_terms_list = null
    $scope.adverseTerms = ''
    $scope.adverseTermsList = null
    $scope.refineSearch()

  $scope.initSubdivisionsSelect = () ->
    if $scope.iteration.subdivisions
      if !$scope.iteration.subdivisions.length
        $scope.iteration.subdivisions = undefined
      else
        """
        Iteration subdivisions are actually an array however we can only set
        one so we pick the first one from array (so ui-select can show the
        selected value) and in the iteration creation we put it back to an array
        """
        $scope.iteration.subdivisions = $scope.iteration.subdivisions[0]

  # =========================
  # -------- Display --------
  # =========================

  $scope.checkUnsearchedSourcesComplete = () ->
    for uss in $scope.manualSources
      if not uss.complete
        return false
    return true

  $scope.checkForNoSources = () ->
    return $scope.workers?.isEmpty() && $scope.manualSources?.length == 0

  $scope.checkForNoAutoSources = () ->
    return $scope.workers?.isEmpty() && $scope.manualSources.length != 0

  $scope.checkForNoResults = () ->
    return not $scope.workers.isEmpty() && $scope.workers.allHaveFinished() and not $scope.workers.hasWithResults()

  $scope.checkForNoHarmoniaResults = () ->
    return not $scope.workers.isEmpty() && not $scope.workers.hasHarmoniaResults()

  $scope.searchNotYetStarted = () ->
    return $scope.iteration.job_status == "not_yet_started"

  $scope.displayKrakenSnapshot = (worker) ->
    worker.kraken_snapshot && (worker.failed or not worker.hasResults() )

  $scope.displaySubdivisionsFacet = () ->
    return $scope.subdivisionsFacet.length > 1

  $scope.searchIsRunning = ->
    $scope.workers.hasRunning()

  $scope.isOverviewLoaded = ( worker ) ->
    $scope.overviews[ worker.id ]?.length > 0

  $scope.getFailedWorkersWithoutManualCheck = () ->
    manualSourceEngines = (ms.engine for ms in $scope.manualSources)
    failedWorkers = (wrk for wrk in $scope.workers.getFailed() when not wrk.engine or wrk.engine.id not in manualSourceEngines)
    return failedWorkers

  $scope.hasFailedWorkersWithoutManualCheck = () ->
    return $scope.getFailedWorkersWithoutManualCheck().length > 0

  $scope.displayAdditionalFilterTerms = () ->
    $scope.filteredWorkers?.length > 0 && $scope.filteredWorkers.hasLexisNexisWorker()

  # =========================
  # ------- Selection--------
  # =========================

  $scope.isWorkerSelected = (worker) ->
    return worker.id == $scope.worker?.id

  $scope.setCountriesFacets = (countriesFacet) ->
    $scope.countriesFacet = countriesFacet

  $scope.setAdditionalFiltersFacets = (filtersFacet) ->
    if filtersFacet? and filtersFacet.length > 0
      $scope.includeAdditionalFilters = $scope.includeAdditionalFilters || {}
      $scope.excludeAdditionalFilters = $scope.excludeAdditionalFilters || {}
      $scope.additionalFiltersFacet = filtersFacet
      filtersFacet.forEach (item) ->
        if not (item.id of $scope.includeAdditionalFilters)
          $scope.includeAdditionalFilters[item.id] = []
        if not (item.id of $scope.excludeAdditionalFilters)
          $scope.excludeAdditionalFilters[item.id] = []
        $scope.isFilterCollapsed[item.id] = false

  $scope.setAdditionalSearchTerms = (scope, existingTerms) ->
    additionalTerms = existingTerms || {}
    if (scope.step.additional_search_terms)
      scope.step.additional_search_terms.forEach (additionalTerm) ->
        if (scope.iteration[additionalTerm.slug])
          # additional_search_terms value should be an array
          # extract name from the object or pass it as is
          if angular.isObject(scope.iteration[additionalTerm.slug])
            additionalTerms[additionalTerm.slug] = [scope.iteration[additionalTerm.slug].name]
          else
            additionalTerms[additionalTerm.slug] = [scope.iteration[additionalTerm.slug]]
        else
          delete additionalTerms[additionalTerm.slug]
    if (Object.keys(additionalTerms).length == 0)
      additionalTerms = undefined
    return additionalTerms

  $scope.setSourcesFacets = (sourcesFacet) ->
    $scope.sourcesFacet = sourcesFacet

  $scope.setAdverseFacets = (adverseFacet) ->
    $scope.adverseFacet = adverseFacet

  $scope.setWorker = (worker) ->
    $scope.worker = worker

  $scope.isOverviewSelected = () ->
    $state.current.url == '/overview'

  $scope.isManualChecksSelected = () ->
    $state.current.url == '/manual'

  $scope.isDataConciergeSelected = () ->
    $state.current.name == 'project.workflow.step.support'

  $scope.showOverview = () ->
    $scope.worker = null
    $state.go('project.workflow.step.iteration.facets.overview')

  # =========================
  # --------- Scope ---------
  # =========================

  $scope.User = User

  $scope.setIteration(iteration)
  $scope.$parent.refine_query = $scope.refine_query =
    query: $scope.iteration.translated_query ? $scope.iteration.query
    sortBy: $scope.iteration.sort_by
  $scope.adverseTerms = $scope.iteration.adverse_terms
  $scope.adverseTermsList = (list for list in adverseTermsLists when list.id == $scope.iteration.adverse_terms_list)[0] if $scope.iteration.adverse_terms_list

  $scope.minScore = iteration.min_score
  $scope.nameVariations = iteration.merged_name_variations

  $scope.handleNameVariationsChange = (value) ->
    $scope.nameVariations = value
    $scope.refinementMade = true

  $scope.handleCountryChange = () ->
    $scope.refinementMade = true

  $scope.search = search
  $scope.includeCountries = search.countries
  $scope.excludeCountries = search.exclude_countries
  $scope.includeSources = search.sources
  $scope.excludeSources = search.exclude_sources
  $scope.includeAdditionalFilters = search.include_additional_filters
  $scope.excludeAdditionalFilters = search.exclude_additional_filters
  $scope.isFilterCollapsed = {}

  $scope.countriesFacet = []
  $scope.sourcesFacet = []
  $scope.adverseFacet = []
  $scope.additionalFiltersFacet = []
  $scope.worker = null

  $scope.setWorkers(workers)
  $scope.setFilteredWorkers(SearchWorkers.decorate([]).set(workers))

  $scope.overview_results_limit = 3
  $scope.overviews = {} # dict to hold arrays of results for fetched results
  $scope.updateOverviews()
  $scope.updateFacets()

  $scope.setManualChecks(manualSources)

  $scope.pollWorkers()

  $scope.sortOrderDesc = $scope.iteration.sort_order_desc
  $scope.sortOrder = if $scope.sortOrderDesc then 'Asc' else 'Desc'

  $scope.timelineDeferred = null
  $scope.timelineMinDate = null
  $scope.timelineMaxDate = null
  $scope.timelineYRanges = null
  $scope.isDeltaSearch = false

  $scope.isCountriesCollapsed = false
  $scope.$parent.activeTab = 'search'

  $scope.iteration.refineCountry = (() ->
    countries = $scope.getSearchCountries($scope.iteration)
    if countries
      return countries[0]
  )()

  $scope.setLoaded(true)

  $scope.noDescriptionAvailable = 'Sorry, there is no description available for this source.'

  $scope.timelineOptions =
    axes:
      x:
        valueFormatter: (ms) ->
          return arachnysDateFilter(new Date(ms))
    height: 200
    showRangeSelector: true
    rangeSelectorHeight: 35
    labelsSeparateLines: true
    series: {News : {showInRangeSelector: true}, Factiva : {showInRangeSelector: false}}
    colors: [
      if $scope.inIframe then 'rgb(27, 117, 188)' else '#f26522'
      '#00aeef'
    ]
    legend: 'always'
    labelsDivWidth: 120
    fillGraph: true
    fillAlpha: 0.15
    # logscale: true
    drawXGrid: false
    setDateRefinementMade: () ->
      $scope.setDateRefinementMade(true)
    drawCallback: (g, is_initial) ->
      if is_initial is true
        return
      $scope.timelineSet = false
    clickCallback: (e, x, point) ->
      day = 60 * 60 * 24 * 1000
      $scope.timelineMinDate = x - day
      $scope.timelineMaxDate = x + day
    zoomCallback: (minDate, maxDate, yRanges) ->
      $scope.setDateRefinementMade(true)
      $scope.setDateRange(minDate, maxDate)
      $scope.timelineOptions.changeUserZoom?(minDate, maxDate)

  $scope.resetCountriesFacet = () ->
    $scope.selectedCountries = {}
    $scope.excludedCountries = {}

  $scope.getAllOverviewResults = () ->
    # create array of all results on overview page
    Array.prototype.concat.apply([], _.values($scope.overviews))

  $scope.allDocsOnPageSelected = () ->
    $scope.allDocsSelected($scope.getAllOverviewResults())

  $scope.toggleSelectedDocsOnPage = () ->
    $scope.toggleSelectedDocs($scope.getAllOverviewResults())

  $scope.saveSelectedDocsOnPageTags = (tagIdsToSave, annotation) ->
    $scope.saveSelectedDocsTags($scope.getAllOverviewResults(), tagIdsToSave, annotation)

  $scope.setLoaded(true)
  $scope.resetCountriesFacet()

  changeStartListenerCanceler = $scope.$on '$stateChangeStart', ( event, toState, toParams, fromState, fromParams, options ) ->
    $scope.setLoaded(false) if toState.name == 'project.workflow.step.iteration'

  $scope.$on '$destroy', () ->
    changeStartListenerCanceler()

  $scope.deletedResultsVisible = false
  $scope.duplicatedResultsVisible = false
  $scope.nonAdverseResultsVisible = false

  if ! User.hasPermission('workflow.can_hide_duplicate_results', false)
    # If the user doesn't have permission to show/hide results, we start
    # off with them being visible.
    $scope.duplicatedResultsVisible = true

  # =========================
  # ----- Soft routing ------
  # =========================

  $scope.setActiveTab( 'search' )
  if $state.current.name == 'project.workflow.step.iteration'
    $state.go( '.facets' )
